export const SCHEDULE_EDITOR_ACTION_DELETE_TASK = "deleteTask"
export const SCHEDULE_EDITOR_ACTION_RESTORE_DELETED_TASK_WITH_AMENDS = "restoreDeletedTaskWithAmends"
export const SCHEDULE_EDITOR_ACTION_RESTORE_DRAFT_SNAPSHOT = "restoreDraftSnapshot"
export const SCHEDULE_EDITOR_ACTION_RESTORE_RECOMMENDATION_APPLICATION = "restoreRecommendationApplication"
export const SCHEDULE_EDITOR_ACTION_RESTORE_DELETED_LEGISLATION = "restoreDeletedLegislation"
